import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlIdentityFieldsFragment = { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string };

export type GqlUpdateIdentityMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlUpdateIdentityInput;
}>;


export type GqlUpdateIdentityMutation = { updateIdentity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } };

export type GqlRefreshIdentityMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlRefreshIdentityMutation = { refreshIdentity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } };

export type GqlIdentityQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlIdentityQuery = { identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } };

export type GqlCreateIdentityMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlCreateIdentityInput;
}>;


export type GqlCreateIdentityMutation = { createIdentity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } };

export type GqlSearchIdentitiesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlSearchIdentitiesInput;
}>;


export type GqlSearchIdentitiesQuery = { searchIdentities: Array<{ id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string, companyDirector?: { id: string, registeredAbroad: boolean, invited: boolean, identityId: string, functions: Array<any>, companyId: string, createdAt: string, updatedAt: string } | null, shareholder?: { id: string, identityId: string, companyId: string, ownerCompanyId?: string | null, createdAt: string, updatedAt: string } | null }> };

export type GqlRatsitIdentityFieldsFragment = { name: string, identityNumberKind: number, identityNumber: string, address?: string | null, countryCode?: string | null, juridicalKind: number, functionCode?: string | null, functionText?: string | null };

export type GqlRatsitCompanyBoardQueryVariables = Types.Exact<{
  orgNumber: Types.Scalars['String']['input'];
}>;


export type GqlRatsitCompanyBoardQuery = { ratsitCompanyBoard: Array<{ name: string, identityNumberKind: number, identityNumber: string, address?: string | null, countryCode?: string | null, juridicalKind: number, functionCode?: string | null, functionText?: string | null }> };

export type GqlRatsitSearchQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String']['input'];
  juridicalKinds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type GqlRatsitSearchQuery = { ratsitSearch: Array<{ name: string, identityNumberKind: number, identityNumber: string, address?: string | null, countryCode?: string | null, juridicalKind: number, functionCode?: string | null, functionText?: string | null }> };

export const IdentityFieldsFragmentDoc = gql`
    fragment IdentityFields on Identity {
  id
  identityNumberKind
  identityNumber
  juridicalKind
  name
  email
  emailMd5
  phone
  countryCode
  address
  userId
  isSwedish
  createdAt
  updatedAt
  companyId
}
    `;
export const RatsitIdentityFieldsFragmentDoc = gql`
    fragment RatsitIdentityFields on RatsitIdentity {
  name
  identityNumberKind
  identityNumber
  address
  countryCode
  juridicalKind
  functionCode
  functionText
}
    `;
export const UpdateIdentityDocument = gql`
    mutation UpdateIdentity($companyId: ID!, $input: UpdateIdentityInput!) {
  updateIdentity(companyId: $companyId, input: $input) {
    ...IdentityFields
  }
}
    ${IdentityFieldsFragmentDoc}`;
export type GqlUpdateIdentityMutationFn = Apollo.MutationFunction<GqlUpdateIdentityMutation, GqlUpdateIdentityMutationVariables>;

/**
 * __useUpdateIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdentityMutation, { data, loading, error }] = useUpdateIdentityMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdentityMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateIdentityMutation, GqlUpdateIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateIdentityMutation, GqlUpdateIdentityMutationVariables>(UpdateIdentityDocument, options);
      }
export type UpdateIdentityMutationHookResult = ReturnType<typeof useUpdateIdentityMutation>;
export type UpdateIdentityMutationResult = Apollo.MutationResult<GqlUpdateIdentityMutation>;
export type UpdateIdentityMutationOptions = Apollo.BaseMutationOptions<GqlUpdateIdentityMutation, GqlUpdateIdentityMutationVariables>;
export const RefreshIdentityDocument = gql`
    mutation RefreshIdentity($companyId: ID!, $id: ID!) {
  refreshIdentity(companyId: $companyId, id: $id) {
    ...IdentityFields
  }
}
    ${IdentityFieldsFragmentDoc}`;
export type GqlRefreshIdentityMutationFn = Apollo.MutationFunction<GqlRefreshIdentityMutation, GqlRefreshIdentityMutationVariables>;

/**
 * __useRefreshIdentityMutation__
 *
 * To run a mutation, you first call `useRefreshIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshIdentityMutation, { data, loading, error }] = useRefreshIdentityMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshIdentityMutation(baseOptions?: Apollo.MutationHookOptions<GqlRefreshIdentityMutation, GqlRefreshIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRefreshIdentityMutation, GqlRefreshIdentityMutationVariables>(RefreshIdentityDocument, options);
      }
export type RefreshIdentityMutationHookResult = ReturnType<typeof useRefreshIdentityMutation>;
export type RefreshIdentityMutationResult = Apollo.MutationResult<GqlRefreshIdentityMutation>;
export type RefreshIdentityMutationOptions = Apollo.BaseMutationOptions<GqlRefreshIdentityMutation, GqlRefreshIdentityMutationVariables>;
export const IdentityDocument = gql`
    query Identity($companyId: ID!, $id: ID!) {
  identity(companyId: $companyId, id: $id) {
    ...IdentityFields
  }
}
    ${IdentityFieldsFragmentDoc}`;

/**
 * __useIdentityQuery__
 *
 * To run a query within a React component, call `useIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIdentityQuery(baseOptions: Apollo.QueryHookOptions<GqlIdentityQuery, GqlIdentityQueryVariables> & ({ variables: GqlIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlIdentityQuery, GqlIdentityQueryVariables>(IdentityDocument, options);
      }
export function useIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlIdentityQuery, GqlIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlIdentityQuery, GqlIdentityQueryVariables>(IdentityDocument, options);
        }
export function useIdentitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlIdentityQuery, GqlIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlIdentityQuery, GqlIdentityQueryVariables>(IdentityDocument, options);
        }
export type IdentityQueryHookResult = ReturnType<typeof useIdentityQuery>;
export type IdentityLazyQueryHookResult = ReturnType<typeof useIdentityLazyQuery>;
export type IdentitySuspenseQueryHookResult = ReturnType<typeof useIdentitySuspenseQuery>;
export type IdentityQueryResult = Apollo.QueryResult<GqlIdentityQuery, GqlIdentityQueryVariables>;
export const CreateIdentityDocument = gql`
    mutation CreateIdentity($companyId: ID!, $input: CreateIdentityInput!) {
  createIdentity(companyId: $companyId, input: $input) {
    ...IdentityFields
  }
}
    ${IdentityFieldsFragmentDoc}`;
export type GqlCreateIdentityMutationFn = Apollo.MutationFunction<GqlCreateIdentityMutation, GqlCreateIdentityMutationVariables>;

/**
 * __useCreateIdentityMutation__
 *
 * To run a mutation, you first call `useCreateIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdentityMutation, { data, loading, error }] = useCreateIdentityMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdentityMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateIdentityMutation, GqlCreateIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateIdentityMutation, GqlCreateIdentityMutationVariables>(CreateIdentityDocument, options);
      }
export type CreateIdentityMutationHookResult = ReturnType<typeof useCreateIdentityMutation>;
export type CreateIdentityMutationResult = Apollo.MutationResult<GqlCreateIdentityMutation>;
export type CreateIdentityMutationOptions = Apollo.BaseMutationOptions<GqlCreateIdentityMutation, GqlCreateIdentityMutationVariables>;
export const SearchIdentitiesDocument = gql`
    query SearchIdentities($companyId: ID!, $input: SearchIdentitiesInput!) {
  searchIdentities(companyId: $companyId, input: $input) {
    ...IdentityFields
    companyDirector {
      id
      registeredAbroad
      invited
      identityId
      functions
      companyId
      createdAt
      updatedAt
    }
    shareholder {
      id
      identityId
      companyId
      ownerCompanyId
      createdAt
      updatedAt
    }
  }
}
    ${IdentityFieldsFragmentDoc}`;

/**
 * __useSearchIdentitiesQuery__
 *
 * To run a query within a React component, call `useSearchIdentitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIdentitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIdentitiesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchIdentitiesQuery(baseOptions: Apollo.QueryHookOptions<GqlSearchIdentitiesQuery, GqlSearchIdentitiesQueryVariables> & ({ variables: GqlSearchIdentitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSearchIdentitiesQuery, GqlSearchIdentitiesQueryVariables>(SearchIdentitiesDocument, options);
      }
export function useSearchIdentitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSearchIdentitiesQuery, GqlSearchIdentitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSearchIdentitiesQuery, GqlSearchIdentitiesQueryVariables>(SearchIdentitiesDocument, options);
        }
export function useSearchIdentitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlSearchIdentitiesQuery, GqlSearchIdentitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlSearchIdentitiesQuery, GqlSearchIdentitiesQueryVariables>(SearchIdentitiesDocument, options);
        }
export type SearchIdentitiesQueryHookResult = ReturnType<typeof useSearchIdentitiesQuery>;
export type SearchIdentitiesLazyQueryHookResult = ReturnType<typeof useSearchIdentitiesLazyQuery>;
export type SearchIdentitiesSuspenseQueryHookResult = ReturnType<typeof useSearchIdentitiesSuspenseQuery>;
export type SearchIdentitiesQueryResult = Apollo.QueryResult<GqlSearchIdentitiesQuery, GqlSearchIdentitiesQueryVariables>;
export const RatsitCompanyBoardDocument = gql`
    query RatsitCompanyBoard($orgNumber: String!) {
  ratsitCompanyBoard(orgNumber: $orgNumber) {
    ...RatsitIdentityFields
  }
}
    ${RatsitIdentityFieldsFragmentDoc}`;

/**
 * __useRatsitCompanyBoardQuery__
 *
 * To run a query within a React component, call `useRatsitCompanyBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatsitCompanyBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatsitCompanyBoardQuery({
 *   variables: {
 *      orgNumber: // value for 'orgNumber'
 *   },
 * });
 */
export function useRatsitCompanyBoardQuery(baseOptions: Apollo.QueryHookOptions<GqlRatsitCompanyBoardQuery, GqlRatsitCompanyBoardQueryVariables> & ({ variables: GqlRatsitCompanyBoardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlRatsitCompanyBoardQuery, GqlRatsitCompanyBoardQueryVariables>(RatsitCompanyBoardDocument, options);
      }
export function useRatsitCompanyBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRatsitCompanyBoardQuery, GqlRatsitCompanyBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlRatsitCompanyBoardQuery, GqlRatsitCompanyBoardQueryVariables>(RatsitCompanyBoardDocument, options);
        }
export function useRatsitCompanyBoardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlRatsitCompanyBoardQuery, GqlRatsitCompanyBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlRatsitCompanyBoardQuery, GqlRatsitCompanyBoardQueryVariables>(RatsitCompanyBoardDocument, options);
        }
export type RatsitCompanyBoardQueryHookResult = ReturnType<typeof useRatsitCompanyBoardQuery>;
export type RatsitCompanyBoardLazyQueryHookResult = ReturnType<typeof useRatsitCompanyBoardLazyQuery>;
export type RatsitCompanyBoardSuspenseQueryHookResult = ReturnType<typeof useRatsitCompanyBoardSuspenseQuery>;
export type RatsitCompanyBoardQueryResult = Apollo.QueryResult<GqlRatsitCompanyBoardQuery, GqlRatsitCompanyBoardQueryVariables>;
export const RatsitSearchDocument = gql`
    query RatsitSearch($searchString: String!, $juridicalKinds: [Int!]!) {
  ratsitSearch(searchString: $searchString, juridicalKinds: $juridicalKinds) {
    ...RatsitIdentityFields
  }
}
    ${RatsitIdentityFieldsFragmentDoc}`;

/**
 * __useRatsitSearchQuery__
 *
 * To run a query within a React component, call `useRatsitSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatsitSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatsitSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      juridicalKinds: // value for 'juridicalKinds'
 *   },
 * });
 */
export function useRatsitSearchQuery(baseOptions: Apollo.QueryHookOptions<GqlRatsitSearchQuery, GqlRatsitSearchQueryVariables> & ({ variables: GqlRatsitSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlRatsitSearchQuery, GqlRatsitSearchQueryVariables>(RatsitSearchDocument, options);
      }
export function useRatsitSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRatsitSearchQuery, GqlRatsitSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlRatsitSearchQuery, GqlRatsitSearchQueryVariables>(RatsitSearchDocument, options);
        }
export function useRatsitSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlRatsitSearchQuery, GqlRatsitSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlRatsitSearchQuery, GqlRatsitSearchQueryVariables>(RatsitSearchDocument, options);
        }
export type RatsitSearchQueryHookResult = ReturnType<typeof useRatsitSearchQuery>;
export type RatsitSearchLazyQueryHookResult = ReturnType<typeof useRatsitSearchLazyQuery>;
export type RatsitSearchSuspenseQueryHookResult = ReturnType<typeof useRatsitSearchSuspenseQuery>;
export type RatsitSearchQueryResult = Apollo.QueryResult<GqlRatsitSearchQuery, GqlRatsitSearchQueryVariables>;